import { TReviewScenario } from '../types';

// Used when no configured scenario matches the selected review basis, so a review
// always returns a credible result set.
export const FALLBACK_SCENARIO: TReviewScenario = {
  id: 'generic',
  name: 'Pre-submission review',
  context: {
    scopeLabel: 'Selected documents',
    documentsAnalyzed: 9,
  },
  findings: [
    {
      id: 'generic-001',
      severity: 'major',
      status: 'unresolved',
      category: 'Consistency',
      title: 'Intended purpose is worded differently across documents',
      summary:
        'The intended purpose in the Instructions for Use does not match the wording used in the technical documentation.',
      whyItMatters:
        'The intended purpose is the reference point for classification, clinical evaluation and labeling. Differing wording is a frequent review question.',
      affectedDocuments: [
        {
          name: 'Instructions for Use',
          location: 'Intended Purpose',
          excerpt: 'The device is intended to support clinicians in assessing patients.',
        },
        {
          name: 'Technical Documentation Summary',
          location: 'Section 1.1',
          excerpt: 'The device is intended for the assessment of patients by trained clinical staff.',
        },
      ],
      resolution: {
        summary: 'Use one wording for the intended purpose and carry it into both documents.',
        change: {
          document: 'Instructions for Use',
          section: 'Intended Purpose',
          currentText: 'The device is intended to support clinicians in assessing patients.',
          proposedText: 'The device is intended for the assessment of patients by trained clinical staff.',
        },
      },
    },
    {
      id: 'generic-002',
      severity: 'minor',
      status: 'unresolved',
      category: 'Traceability',
      title: 'Referenced verification evidence is not linked',
      summary: 'A requirement states that verification was performed without naming the report that holds the result.',
      whyItMatters: 'Named evidence keeps the requirement traceable during review and in later submissions.',
      affectedDocuments: [
        {
          name: 'Requirements Checklist',
          location: 'Requirement 17.2',
          excerpt: 'Compliance demonstrated by software verification.',
        },
      ],
      resolution: {
        summary: 'Name the verification report and the section that holds the result.',
        change: {
          document: 'Requirements Checklist',
          section: 'Requirement 17.2',
          currentText: 'Compliance demonstrated by software verification.',
          proposedText: 'Compliance demonstrated by Software Verification Report SVR-004, Section 6.3.',
        },
      },
    },
    {
      id: 'generic-003',
      severity: 'needsReview',
      status: 'unresolved',
      category: 'Risk',
      title: 'Risk control effectiveness is not confirmed after the last update',
      summary:
        'A risk control was updated in the risk management file, but the verification of its effectiveness still points to the previous revision.',
      whyItMatters: 'Effectiveness of a changed risk control has to be confirmed against the revision that is in use.',
      affectedDocuments: [
        {
          name: 'Risk Management File',
          location: 'Risk control RC-12',
          excerpt: 'Effectiveness verified in revision 2 of the verification protocol.',
        },
      ],
      resolution: {
        summary: 'Confirm effectiveness against the current protocol revision and record the result.',
      },
    },
  ],
};
